module.exports = __webpack_public_path__ + "static/deathlock_wight-c466b498e9baba6780cd29836e9fb9ed.png";